{
  "organizationLabel": "Organization:",
  "profileDropdownAccountInfoItem": "Account info (internal)",
  "profileDropdownAccountSettingsHeader": "Account Settings",
  "profileDropdownProductSettingsHeader": "Product Settings",
  "profileDropdownUserSettingsItem": "Preferences",
  "profileLegalNoticesMenuItem": "Legal notices",
  "signOut": "Sign Out",
  "themeInfoTooltip": "Not all applications support dark theme.",
  "userProfileName": "{firstName} {lastName}",
  "userThemeSwitchLabel": "Dark theme"
}
